"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFileByUrl = fetchFileByUrl;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v2/files';

function fetchFileByUrl(url) {
  var query = {
    url: url,
    allowRedirects: true
  };
  return _apiClient.default.get(BASE_URI + "/resolve", {
    query: query
  });
}